var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataStructured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16.605V13.5a1.5 1.5 0 00-1.5-1.5h-6V9h6.75A1.5 1.5 0 0021 7.5V3a1.5 1.5 0 00-1.5-1.5h-15A1.5 1.5 0 003 3v4.5A1.5 1.5 0 004.5 9h6.75v3h-6a1.5 1.5 0 00-1.5 1.5v3.105a3 3 0 101.5 0V13.5h6v3H9v6h6v-6h-2.25v-3h6v3.105a3 3 0 101.5 0zM6 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7.5-1.5v3h-3v-3h3zm-9-10.5V3h15v4.5h-15zm15 13.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: "#45464F"
  })));
}
export default SvgDataStructured;